/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-27 21:37:08
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyFileThumbList from "../BsyFileThumbList";
import BsyFileUpload from "../BsyFileUpload";
import "./index.css";
import BsyThumbList from "../BsyThumbList";
import BsySubformBase from "../BsySubformBase";

class BsySubformFileUpload extends BsySubformBase {
  static defaultProps = {
    baseCls: "bsy-subform-upload",
  };

  constructor(props) {
    super({
      baseCls: "bsy-subform-upload",
      scene: "",
      ...props,
    });

    this.element = React.createRef();
  }

  getValue = () => {
    return this.value;
  };
  setValue = (value) => {
    this.value = value;
    this.setState({
      value: value,
    });
  };
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    const { subform } = this.options;
    if (subform && this.hasFocus) {
      this.hasFocus = false;
      BsyUtils.applyFunc(
        this,
        this.options.onStopEdit,
        [this.value, null, this],
        !1
      );
    }
  }

  popUpPane = () => {
    const { value } = this.state;
    let that = this;
    that.isChange = false;
    return (
      <BsyFileUpload
        {...that.options}
        getContext={null}
        download={false}
        customCls={""}
        width={"auto"}
        baseCls={"bsy-upload subform"}
        value={value}
        dataId={this.props.dataId}
        formId={this.props.formId}
        appId={this.props.appId}
        is_file_down={this.props.is_file_down}
        online_edit={this.props.online_edit}
        online_edit_record={this.props.online_edit_record}
        onStopEdit={(e) => {
          that.isChange = true;

          that.value = e;
          that.setState(
            {
              value: [...e],
            },
            () => {
              BsyUtils.applyFunc(
                that,
                that.props.onStopEdit,
                [e, null, that],
                !1
              );
            }
          );
        }}
      ></BsyFileUpload>
    );
  };

  popUpPaneClose = (e) => {
    let that = this;
    var isfnd = BsyUtils.closestClass(e.target, "fui_file_preview_v1");
    if (isfnd) {
      return;
    }
    if (!that.isChange)
      BsyUtils.applyFunc(
        that,
        that.props.onClose,
        [that.state.value, null, that],
        !1
      );
    return !1;
  };
  renderDisablePane = () => {
    const { value } = this.state;
    const { hasPreview, isformdata } = this.options;
    let that = this;
    if (BsyUtils.isObjectEmpty(value)) {
      return (
        <div
          className={"bsy_form_item_disable "}
          data-watermark={React.language("content.empty")}
        ></div>
      );
    }
    if (isformdata) {
      return (
        <div
          className={"bsy_form_item_disable "}
          data-watermark={React.language("content.empty")}
        >
          <BsyFileUpload
            {...that.options}
            getContext={null}
            baseCls={"bsy-upload "}
            download={false}
            value={value}
            enable={false}
            dataId={this.props.dataId}
            formId={this.props.formId}
            appId={this.props.appId}
            is_file_down={this.props.is_file_down}
            online_edit={this.props.online_edit}
            online_edit_record={this.props.online_edit_record}
            onStopEdit={(e) => {
              this.isChange = true;

              this.value = e;
              this.setState(
                {
                  value: [...e],
                },
                () => {
                  BsyUtils.applyFunc(
                    this,
                    this.props.onStopEdit,
                    [e, null, this],
                    !1
                  );
                }
              );
            }}
          ></BsyFileUpload>
        </div>
      );
    }
    return (
      <div
        className={"bsy_form_item_disable "}
        data-watermark={React.language("content.empty")}
      >
        <BsyThumbList
          {...that.options}
          dataId={this.props.dataId}
          formId={this.props.formId}
          appId={this.props.appId}
          is_file_down={this.props.is_file_down}
          online_edit={this.props.online_edit}
          online_edit_record={this.props.online_edit_record}
          widget={this.options}
          getContext={null}
          files={value}
          onStopEdit={(e) => {
            that.isChange = true;

            that.value = e;
            that.setState(
              {
                value: [...e],
              },
              () => {
                BsyUtils.applyFunc(
                  that,
                  that.props.onStopEdit,
                  [e, null, that],
                  !1
                );
              }
            );
          }}
        />
      </div>
    );
  };

  renderList = () => {
    const { value } = this.state;
    const { hasPreview, hasTooltip, scene } = this.options;
    switch (scene) {
      case "subform": {
        return (
          <BsyThumbList
            {...this.options}
            dataId={this.props.dataId}
            formId={this.props.formId}
            appId={this.props.appId}
            is_file_down={this.props.is_file_down}
            online_edit={this.props.online_edit}
            online_edit_record={this.props.online_edit_record}
            widget={this.options}
            getContext={null}
            hasPreview={hasPreview}
            hasTooltip={hasTooltip}
            files={value}
            onStopEdit={(e) => {
              this.isChange = true;

              this.value = e;
              this.setState(
                {
                  value: [...e],
                },
                () => {
                  BsyUtils.applyFunc(
                    this,
                    this.props.onStopEdit,
                    [e, null, this],
                    !1
                  );
                }
              );
            }}
          />
        );
        break;
      }
      case "datatable":
      default: {
        return (
          <BsyFileThumbList
            {...this.options}
            dataId={this.props.dataId}
            formId={this.props.formId}
            appId={this.props.appId}
            is_file_down={this.props.is_file_down}
            online_edit={this.props.online_edit}
            online_edit_record={this.props.online_edit_record}
            widget={this.options}
            getContext={null}
            hasPreview={hasPreview}
            hasTooltip={hasTooltip}
            files={value}
            onStopEdit={(e) => {
              this.isChange = true;

              this.value = e;
              this.setState(
                {
                  value: [...e],
                },
                () => {
                  BsyUtils.applyFunc(
                    this,
                    this.props.onStopEdit,
                    [e, null, this],
                    !1
                  );
                }
              );
            }}
          />
        );
      }
    }
  };

  render() {
    const { value } = this.state;
    const { cssName, css, hasPreview, hasTooltip, download, scene } =
      this.options;
    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }
    return (
      <div
        className={cssName}
        style={css}
        ref={this.element}
        onClick={(e) => {
          this._onTriggerClick(e, 340);
        }}
      >
        <div className="select-trigger">
          {this.renderList()}
          {download &&
          !this.options.isformdata &&
          !BsyUtils.isObjectEmpty(value) ? (
            <div
              className="download"
              onClick={(e) => {
                BsyUtils._package("", value, this.options);
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <i className="icon-vip-center-excel-import"></i>
            </div>
          ) : (
            ""
          )}
          <div
            className={
              "iconSelect " +
              (!BsyUtils.isObjectEmpty(value) ? "has-value" : "")
            }
          >
            <i className={"widget-icon icon-widget-upload"}></i>
            <i
              className="widget-icon icon-dingding-guide-close"
              onClick={this.clear}
            ></i>
          </div>
        </div>
      </div>
    );
  }
}

export default BsySubformFileUpload;
